import { useRecoilCallback } from 'recoil'

import * as atoms from 'src/atoms/search'
import * as mainMapAtoms from 'src/atoms/main-map'

export const useClearLocation = () => {
  const clear = useRecoilCallback(({ set }) => (keepSearchResults = false) => {
    set(mainMapAtoms.streetView, false)
    set(atoms.internalGooglePlaceId, undefined)
    set(atoms.selectedLocationId, undefined)
    if (!keepSearchResults) {
      set(atoms.googleSearchString, undefined)
      set(atoms.googleSearchResult, undefined)
    }
  })

  return clear
}
